module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABPElEQVRoQ+3YwW3CQBCF4R3bd1JCOgglWLZcR0gHpCIoxBbuIKGDlJAGrEErQQHsm3kjpOXkAyP+b5fDriW9+EdevD9VQPQO1h2oOwCuQP0LTdO0V9XPeZ6/wcUsGod2oO/7t67r/lJKO1U9L8vyVVQBDEGA/LvDMByapjnl5wgEDIhGmAAiEWaAKIQpIAJhDmAjXABMhBuAhXAFMBDuAG8EBeCJoAG8EFSAB4IOsEaEACwRYYB8l2jb9kdE3lX1um1bv67r/7NXgxDA/SJ0SSnl21xxfMbSAZbxdIB1PBXgEU8DeMVTAJ7x7gDveFcAI94NwIp3ATDjzQHseFNARLwZICreBBAZbwIYx/FXRD7QU+Wzx+jH9+HTaH69LiLH0vN8abgZAA1A5+EdQAPQ+QpAVxCdrzuAriA6fwPLN09AyorORAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow2next.png
// module id = IIjP
// module chunks = 1